class ReplyOmitted {
  constructor(targetSelector, rootSelector = document) {
    this.root = rootSelector;
    this.targets = this.root.querySelectorAll(targetSelector);

    this.targets.forEach((target) => this.initializeTarget(target));
  }

  initializeTarget(target) {
    if (!target) return;

    const omittedSelector = target.dataset?.jsOmittedSelector;
    const omittedArea = target.querySelector(omittedSelector);
    const unlockButton = target.querySelector(target.dataset?.jsOmittedUnlockSelector);

    if (!omittedArea || !unlockButton) return;

    this.handleUnlockButtonVisibility(omittedArea, unlockButton);
    this.addUnlockButtonListener(omittedArea, unlockButton, omittedSelector);
  }

  handleUnlockButtonVisibility(omittedArea, unlockButton) {
    const isContentOmitted =
      omittedArea.offsetHeight > 0 &&
      omittedArea.scrollHeight > 0 &&
      omittedArea.offsetHeight < omittedArea.scrollHeight;

    // omittedArea の高さが全開時よりも小さい場合に unlockButton を表示する
    if (isContentOmitted) {
      // FIXME: 該当classのdisplayプロパティを削除し　、hidden に置き換え出来た場合に `remove('hidden');` が不要になる
      unlockButton.classList.remove('hidden');
      unlockButton.classList.add('block');
    }
  }

  addUnlockButtonListener(omittedArea, unlockButton, omittedSelector) {
    unlockButton.addEventListener('click', () => {
      omittedArea.classList.remove(omittedSelector.replace('.', ''));
      unlockButton.remove();
    });
  }
}

export default ReplyOmitted;
